import { render, staticRenderFns } from "./ProFeatureModal.vue?vue&type=template&id=2bc04ff4"
import script from "./ProFeatureModal.vue?vue&type=script&lang=js"
export * from "./ProFeatureModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports